<button
  mat-stroked-button
  type="button"
  appSendAnalytics
  *ngIf="isOutline; else showFlatButton"
  [attr.aria-label]="label | translate"
  [id]="buttonId"
  [disabled]="disabled"
  [ngStyle]="{ 'background-color': backgroundColor, color: iconColor }"
  [ngClass]="{ 'body-medium-icon': isSmall }"
  class="roller-icon-button outline"
  (click)="action.emit($event)"
  #genericIconButton>
  <mat-icon>{{ icon }}</mat-icon>
</button>

<ng-template #showFlatButton>
  <button
    mat-flat-button
    type="button"
    appSendAnalytics
    *ngIf="!isCdkFocusInitial; else showFlatFocusInitial"
    [attr.aria-label]="label | translate"
    [ngStyle]="{ 'background-color': backgroundColor, color: iconColor }"
    [ngClass]="{ 'body-medium-icon': isSmall }"
    [disabled]="disabled"
    [id]="buttonId"
    class="roller-icon-button flat"
    (click)="action.emit($event)"
    #genericIconButton>
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</ng-template>

<ng-template #showFlatFocusInitial>
  <button
    mat-flat-button
    type="button"
    appSendAnalytics
    cdkFocusInitial
    [attr.aria-label]="label | translate"
    [id]="buttonId"
    [ngClass]="{ 'body-medium-icon': isSmall }"
    [ngStyle]="{ 'background-color': backgroundColor, color: iconColor }"
    [disabled]="disabled"
    class="roller-icon-button flat"
    (click)="action.emit($event)"
    #genericIconButton>
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</ng-template>
